module.exports = __webpack_public_path__ + "img/busca-avancada-pesca-desportiva-2.d9bf8cc2.jpg";